import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
  imageFormatter,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getArticles, deleteArticle } from "../../../../api/article";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

/** ===== Formatters adicionales ===== */

// Badge para estado
function statusFormatter(cell) {
  const status = (cell || "").toLowerCase();
  const map = {
    draft: "badge-light",
    published: "badge-light-success",
    scheduled: "badge-light-warning",
    archived: "badge-light-secondary",
  };
  const cls = map[status] || "badge-light";
  return <span className={`badge ${cls}`}>{cell || "—"}</span>;
}

// Badge booleano
function boolFormatter(cell) {
  const val = !!cell;
  return (
    <span className={`badge ${val ? "badge-light-success" : "badge-light-danger"}`}>
      {val ? "Yes" : "No"}
    </span>
  );
}

// Tags (muestra hasta 3)
function tagsFormatter(cell) {
  if (!cell || !Array.isArray(cell) || cell.length === 0) return "—";
  const list = cell.slice(0, 3).join(", ");
  const extra = cell.length > 3 ? ` +${cell.length - 3}` : "";
  return `${list}${extra}`;
}

/** ===== Normalización de datos para la tabla ===== */
function getData(articles) {
  let data = [];
  for (let i = 0; i < articles.length; ++i) {
    const a = articles[i];
    const elem = {
      id: a._id,
      image: a.cover.url, // legacy
      title: a.title || "(untitled)",
      status: a.status,
      featured: !!a.featured,
      active: a.active !== false, // default true
      tags: Array.isArray(a.tags) ? a.tags : [],
      publishedAt: a.publishedAt,
      createdAt: a.createdAt,
      // opcional: slug si quieres mostrarlo
      // slug: a.slug,
    };
    data = data.concat(elem);
  }
  return data;
}

export default function ArticlesPage() {
  const [data, setData] = useState([]);
  const [articleId, setArticleId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-article/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setArticleId(cell);
              setOpenConfirmDialog(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    {
      dataField: "image",
      text: "",
      formatter: imageFormatter,
      headerStyle: () => ({ width: "50px" }),
    },
    { dataField: "title", text: "Title", sort: true },
    {
      dataField: "status",
      text: "Status",
      formatter: statusFormatter,
      sort: true,
      headerStyle: () => ({ width: "120px" }),
    },
    {
      dataField: "featured",
      text: "Featured",
      formatter: boolFormatter,
      sort: true,
      headerStyle: () => ({ width: "110px" }),
    },
    {
      dataField: "active",
      text: "Active",
      formatter: boolFormatter,
      sort: true,
      headerStyle: () => ({ width: "110px" }),
    },
    {
      dataField: "tags",
      text: "Tags",
      formatter: tagsFormatter,
      sort: false,
    },
    {
      dataField: "publishedAt",
      text: "Published at",
      formatter: dateFormatter,
      sort: true,
      headerStyle: () => ({ width: "160px" }),
    },
    {
      dataField: "createdAt",
      text: "Created at",
      formatter: dateFormatter,
      sort: true,
      headerStyle: () => ({ width: "160px" }),
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: () => ({ width: "150px" }),
    },
  ];

  useEffect(() => {
    getArticles()
      .then((res) => {
        if (res.status === 200) {
          setData(getData(res.data));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get articles.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Articles list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-article")}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={data} columns={columns} />
          <ConfirmDialog
            title={"Are you sure you want to remove this article?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteArticle(articleId)
                .then((res) => {
                  if (res.status === 204) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Article removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove article.",
                  });
                });
            }}
          >
            {"This action cannot be undone."}
          </ConfirmDialog>
        </CardBody>
      </Card>
    </>
  );
}
